const appVersion = 8;

module.exports = { appVersion };
